<template>
  <div class="awards_side_info">
    <div
        v-if="profile.data.segment !== 'sports'"
        :class="{
          'golden_lens_info': true,
          [profile.data.is_pro ? 'is_pro': 'is_basic']: true
        }"
       v-on="!profile.data.is_pro ? { click: () => $router.push(`/profiles/${profile.slug}?upgrade`) } : {}"
    >
      <v-icon class="notranslate" large>fa-trophy</v-icon>
      <span>{{ $t(profile.data.is_pro
        ? 'Winners automatically compete for Golden Lens'
        : 'Upgrade to Pro plan to compete for Golden Lens'
      ) }}</span>
    </div>
    <strong class="open_until">{{ $t('Open until') }} {{ moment(award['closing_date']) }}</strong>
    <p class="rules_important_notes_heading" v-if="award['rules_important_notes']">{{ $t('Important notes') }}</p>
    <ul class="rules_important_notes" v-if="award['rules_important_notes']">
      <li v-for="(rule, index) in award['rules_important_notes']" :key="index">{{rule[lang]}}</li>
    </ul>
    <v-btn style="margin: 12px 0;"
           depressed
           block
           large
           color="warning"
           :href="award[`rules_page_${lang}_url`]"
           target="_blank"
    >
      <v-icon class="notranslate" left dark>warning</v-icon>
      {{ $t('Read the rules') }}
      <v-icon class="notranslate" right dark>warning</v-icon>
    </v-btn>
    <div class="totals" v-if="entries_to_submit >= 1">
      <h4>{{ $t('Your submission') }}</h4>
      <ul>
        <li class="entries_sent">{{entries_to_submit}} {{ $t('entries to submit') }}</li>
        <li class="free_entries" v-if="free_entries_available >= 1">{{ free_entries_available }} {{ $t('free entries') }}</li>
        <li class="extra_entries" v-if="extra_entries >= 1">{{ extra_entries }} {{ $t('extra entries') }}</li>
        <li class="entry_price" v-if="extra_entries >= 1">{{ each_extra_entry_price }} {{ $t('for each extra entry') }}</li>
      </ul>
      <div class="submit_award" v-if="entries_to_submit >= 1 && readyToSubmit">
        <strong class="total">{{ total_to_pay_formatted }}</strong>
        <v-btn
          depressed
          color="success"
          class="submit"
          @click="$emit('submit')"
        >{{ total_to_pay > 0 ? $t('Pay and submit') : $t('Submit') }}</v-btn>
      </div>
      <small class="rules_agreement">{{ $t('I accept the rules') }}</small>
    </div>
  </div>
</template>

<script>
import * as moment from 'moment'
import VCard from 'vuetify/es5/components/VCard/VCard'
export default {
  name: 'AwardsSideInfo',
  components: {
    VCard
  },
  props: {
    award: {
      type: Object,
      required: true
    },
    submission: {
      type: Array,
      required: true
    },
    readyToSubmit: {
      type: Boolean,
      required: false
    },
    entries_to_submit: {
      type: Number,
      required: true
    },
    free_entries_available: {
      type: Number,
      required: true
    },
    extra_entries: {
      type: Number,
      required: true
    },
    total_to_pay: {
      type: Number,
      required: true
    },
    profile: {
      type: Object,
      required: true
    }
  },
  computed: {
    lang: function () {
      return this.$store.state.user.language ? this.$store.state.user.language : 'en'
    },
    total_to_pay_formatted: function () {
      if (this.$store.state.user['address']['country'].toLowerCase() === 'br') {
        return `R$ ${(this.total_to_pay / 100).toFixed(2).replace('.', ',')}`
      } else {
        return `U$ ${(this.total_to_pay / 100).toFixed(2)}`
      }
    },
    each_extra_entry_price: function () {
      let entry_field, currency, value, formatted_value
      if (this.$store.state.user['address']['country'].toLowerCase() === 'br') {
        entry_field = 'entry_price_brl'
        currency = 'R$'
      } else {
        entry_field = 'entry_price_usd'
        currency = 'U$'
      }
      value = parseInt(this.award[entry_field], 10)
      if (!this.profile.data.is_pro) {
        value *= 2
      }
      formatted_value = (value/100).toFixed(2)
      if (currency === 'R$') {
        formatted_value = formatted_value.replace('.', ',')
      }
      return `${currency} ${formatted_value}`
    }
  },
  methods: {
    moment: function (date, subtractDays = 0) {
      const lang = this.$store.state.user.language
      let format
      if (lang === 'pt') {
        moment.locale('pt-BR')
        format = 'DD/MM/YYYY'
      } else {
        moment.locale('en-US')
        format = 'MMM Do YYYY'
      }
      return moment(date).subtract(subtractDays, 'days').format(format)
    }
  }
}
</script>

<style scoped lang="scss">
  .awards_side_info {
    width: 100%;
    background: rgb(245, 245, 245);
    padding: 18px;
    border-radius: 4px;
    .golden_lens_info {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 12px;
      margin-bottom: 12px;
      border-radius: 2px;
      &.is_pro {
        background: var(--success-color);
      }
      &.is_basic {
        background: var(--info-color);
        cursor: pointer;
      }
      .v-icon {
        color: rgba(255,255,255,0.7);
      }
      span {
        margin-left: 12px;
        font-size: 17px;
        line-height: 1.2em;
        color: #fff;
      }
    }
    p {
      margin: 18px 0;
    }
    .single-profile {
      width: 100%;
      position: relative;
      margin: 18px 0;
      background: #fff;
      border-radius: 8px;
      overflow: hidden;
      box-shadow: 0 2px 4px rgba(0,0,0,0.18);
      &:first-child {
        margin-top: 0;
      }
      .featured-image {
        width: 100%;
        height: 0;
        padding-top: 50%;
        background-size: cover;
        background-position: center;
        background-color: #eee;
      }
      &.empty .featured-image {
        padding-top: calc(33.33% - 54px);
      }
      .basic-info {
        margin: 12px 12px 12px calc(33.33% + 24px);
        clear: both;
        .profile-picture {
          position: absolute;
          width: 33.33%;
          background-size: cover;
          border-radius: 50%;
          bottom: 78px;
          left: 12px;
          border: 4px solid #fff;
          background-color: #eee;
          transform: translateY(50%);
          &::after {
            content: '';
            display: block;
            padding-top: 100%;
          }
        }
        strong {
          display: block;
          font-size: 20px;
          color: rgba(0, 0, 0, 0.87);
        }
        .segment {
          font-size: 16px;
          color: rgba(0, 0, 0, 0.54);
        }
      }
    }
    .open_until {
      display: inline-block;
      height: 24px;
      line-height: 24px;
      font-size: 16px;
      color: #fff;
      margin: 18px 0;
      position: relative;
      z-index: 1;

      &::before {
        content: '';
        display: block;
        position: absolute;
        top: 0;
        right: -6px;
        bottom: 0;
        left: -6px;
        z-index: -1;
        transform: skewX(-6deg);
        background: #212121;
      }
    }
    .rules_important_notes_heading {
      display: inline-block;
      height: 32px;
      line-height: 32px;
      font-size: 19px;
      color: #fff;
      margin: 18px 0;
      position: relative;
      z-index: 1;
      font-weight: bold;

      &::before {
        content: '';
        display: block;
        position: absolute;
        top: 0;
        right: -6px;
        bottom: 0;
        left: -6px;
        z-index: -1;
        transform: skewX(-6deg);
        background: var(--error-color);
      }
    }
    .rules_important_notes {
      list-style: none;
      padding: 0;
      li {
        color: #fff;
        margin: 8px 0;
        background: var(--warning-color);
        padding: 4px 6px;
        line-height: 24px;
        &::before {
          content: "warning";  /* Add content: \2022 is the CSS Code/unicode for a bullet */
          font-family: 'Material Icons';
          color: rgba(0,0,0,0.54);
          margin-right: 4px;
          float: left;
        }
      }
    }
    .totals {
      margin-top: 24px;
      ul {
        li {
          line-height: 28px;
        }
      }
      .submit_award {
        margin: 24px 0 0;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px solid rgba(0,0,0,0.12);
        border-radius: 4px;
        padding: 6px 0;
        .total {
          text-align: center;
          font-family: 'Roboto Mono', monospace;
          font-size: 20px;
          margin-right: 12px;
          color: var(--success-color);
          font-weight: bold;
        }
      }
      .submit {
        display: block;
      }
      .rules_agreement {
        margin-top: 12px;
        display: block;
      }
    }
  }
</style>

<i18n>
  {
    "en": {
      "Read the rules": "Read the all the rules",
      "Winners automatically compete for Golden Lens": "The winners of this contest automatically compete for the annual Golden Lens award",
      "Upgrade to Pro plan to compete for Golden Lens": "Upgrade to the Pro plan to compete for the annual Golden Lens award",
      "Important notes": "Oops! Make sure to check the rules:",
      "Open until": "Awards open to submissions until",
      "Your submission": "Your submission",
      "entries to submit": "entries to submit",
      "free entries": "free entries",
      "extra entries": "extra entries",
      "for each extra entry": "for each extra entry",
      "Pay and submit": "Pay and submit",
      "Submit": "Submit",
      "I accept the rules": "By submitting you state that you have read and understood the rules, accept and agree to them, and also state that your submission respects it."
    },
    "pt": {
      "Read the rules": "Ler regulamento completo",
      "Winners automatically compete for Golden Lens": "Os premiados neste concurso concorrem automaticamente ao prêmio anual Lente de Ouro",
      "Upgrade to Pro plan to compete for Golden Lens": "Ative o plano Pro para competir ao prêmio anual Lente de Ouro",
      "Important notes": "Ops, cuidado com as regras:",
      "Open until": "Awards aberto para envios até",
      "Your submission": "Seu envio",
      "entries to submit": "entrada(s) a enviar",
      "free entries": "entrada(s) gratuita(s)",
      "extra entries": "entrada(s) extra(s)",
      "for each extra entry": "por cada entrada extra",
      "Pay and submit": "Pagar e enviar",
      "Submit": "Enviar",
      "I accept the rules": "Ao finalizar, você atesta que leu e compreendeu o regulamento, aceita as regras e concorda com elas, declara também que seu envio está de acordo."
    }
  }
</i18n>
